import type {
  SearchResultType,
  SearchResultValue,
} from 'feature/linkedValueSearch/types';
import type {LinkedValueLink} from 'schemaDefinition/types';
import type {SearchResult} from 'services/elastic/types';
import {isNullish} from 'schemaDefinition/functions/isNullish';
import type {EntityIdOnly, EntitySearchState} from '../types';
import {getIndexOnPage} from './getIndexOnPage';

export const getCurrentEntity = (
  state: EntitySearchState,
  viewEntity: EntityIdOnly | undefined,
  toEntityType: SearchResultType | undefined,
  currentEntityIdx: number | undefined,
  searchPage: number,
  pageSize: number,
  searchResult: SearchResult<SearchResultValue>,
  currentSourceValue: LinkedValueLink | undefined,
  searchEntityType: SearchResultType,
): {
  entity: EntityIdOnly | undefined;
  type: SearchResultType | undefined;
} => {
  const currentEntityPageIdx = getIndexOnPage(
    currentEntityIdx,
    searchPage,
    pageSize,
  );

  const currentEntity =
    state === 'browse' && !isNullish(currentEntityPageIdx)
      ? searchResult.hits[currentEntityPageIdx]
        ? ({
            id: searchResult.hits[currentEntityPageIdx].id,
          } as EntityIdOnly)
        : undefined
      : (state === 'viewEntity' || state === 'navigate') && viewEntity
        ? viewEntity
        : undefined;
  const currentEntityType: SearchResultType | undefined =
    state === 'navigate'
      ? toEntityType
      : currentEntity
        ? (((currentEntity.id === currentSourceValue?.entityId
            ? currentSourceValue?.type
            : undefined) ?? searchEntityType) as SearchResultType)
        : searchEntityType;

  return {
    entity: currentEntity,
    type: currentEntityType,
  };
};
